import { 
  collection, 
  getDocs, 
  getDoc,
  doc,
  query, 
  where 
} from "firebase/firestore";
import { db } from "../lib/firebase";

export const getCategories = async () => {
  const q = query(collection(db, "categories"), where("isDeleted", "==", false), where("isActive", "==", true));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

export const getCategoryById = async (id) => {
  const d = await getDoc(doc(db, "categories", id));
  if (!d.exists()) return null;
  return { id: d.id, ...d.data() };
};
